var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.8,7C5.1,7,4.5,7.6,4.5,8.3v15.5c0,0.7,0.6,1.3,1.3,1.3h20.5c0.7,0,1.3-0.6,1.3-1.3V8.3 c0-0.7-0.6-1.3-1.3-1.3H5.8z M25.5,12.8c0,1-0.9,1.9-1.9,1.9c-0.8,0-1.5-0.5-1.8-1.3c-2,0.1-3.3,1-4.2,2.2c-1,1.3-1.3,2.9-1.3,4.1 c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.9-0.5-2.3-1.3-3.6C13,15,12,14.1,10.9,14.1c-1,0-1.8,0.5-2.3,1.1 c-0.6,0.7-0.9,1.5-0.9,2c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0-0.9,0.4-1.9,1.2-2.8c0.7-0.9,1.8-1.6,3.2-1.6 c1.7,0,3,1.3,3.9,2.6c0.3,0.4,0.5,0.9,0.8,1.4c0.3-0.7,0.6-1.4,1.1-2c1.1-1.4,2.7-2.5,5.1-2.7c0.2-0.8,1-1.3,1.8-1.3 C24.6,10.9,25.5,11.8,25.5,12.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimate);
export default __webpack_public_path__ + "static/media/animate.1a20762f681eae40e1dad822f5f6186e.svg";
export { ForwardRef as ReactComponent };